import http from '@/http'
import createCrudModule from 'vuex-crud'
import { withDataFilter } from '@/store/index'

const store = createCrudModule({
  client: http,
  resource: 'advantages',
  urlRoot: 'advantages',

  state: {
    total: 0,
    meta: {}
  },

  parseList(response) {
    return Object.assign({}, response, {
      data: response.data.data,
      total: response.data.total,
      meta: response.meta
    })
  },

  onFetchListSuccess(state, response) {
    state.total = response.total
    state.meta = response.meta
  }
})

export default withDataFilter(store)
